import { ILaya } from "./ILaya";
import { Input } from "./laya/display/Input";
import { Stage } from "./laya/display/Stage";
import { InputManager } from "./laya/events/InputManager";
import { SoundManager } from "./laya/media/SoundManager";
import { Loader } from "./laya/net/Loader";
import { LocalStorage } from "./laya/net/LocalStorage";
import { Render } from "./laya/renders/Render";
import { RenderSprite } from "./laya/renders/RenderSprite";
import { Context } from "./laya/renders/Context";
import { HTMLCanvas } from "./laya/resource/HTMLCanvas";
import { Browser } from "./laya/utils/Browser";
import { Timer } from "./laya/utils/Timer";
import { PrimitiveSV } from "./laya/webgl/shader/d2/value/PrimitiveSV";
import { TextureSV } from "./laya/webgl/shader/d2/value/TextureSV";
import { RenderSpriteData, Value2D } from "./laya/webgl/shader/d2/value/Value2D";
import { Mouse } from "./laya/utils/Mouse";
import { MeshVG } from "./laya/webgl/utils/MeshVG";
import { MeshQuadTexture } from "./laya/webgl/utils/MeshQuadTexture";
import { MeshTexture } from "./laya/webgl/utils/MeshTexture";
import { WeakObject } from "./laya/utils/WeakObject";
import { RenderStateContext } from "./laya/RenderEngine/RenderStateContext";
import { LayaEnv } from "./LayaEnv";
import { URL } from "./laya/net/URL";
import { Config } from "./Config";
import { Shader3D } from "./laya/RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "./laya/layagl/LayaGL";
import { Material } from "./laya/resource/Material";
import { VertexElementFormat } from "./laya/renders/VertexElementFormat";
import { Stat } from "./laya/utils/Stat";
import { RenderPassStatisticsInfo } from "./laya/RenderEngine/RenderEnum/RenderStatInfo";
import { VertexMesh } from "./laya/RenderEngine/RenderShader/VertexMesh";
export class Laya {
    static init(...args) {
        if (Laya._inited)
            return Promise.resolve();
        Laya._inited = true;
        Stat.renderPassStatArray.length = RenderPassStatisticsInfo.RenderPassStatisticCount;
        let stageConfig;
        if (typeof (args[0]) === "number") {
            stageConfig = {
                designWidth: args[0],
                designHeight: args[1]
            };
        }
        else
            stageConfig = args[0];
        Browser.__init__();
        URL.__init__();
        let mainCanv = Browser.mainCanvas = new HTMLCanvas(true);
        Laya._setStyleInfo(mainCanv);
        if (!Browser.onKGMiniGame && !Browser.onAlipayMiniGame && !Browser.onTBMiniGame) {
            Browser.container.appendChild(mainCanv.source);
        }
        Browser.canvas = new HTMLCanvas(true);
        Browser.context = Browser.canvas.getContext('2d');
        Browser.supportWebAudio = SoundManager.__init__();
        Browser.supportLocalStorage = LocalStorage.__init__();
        systemTimer = new Timer(false);
        physicsTimer = new Timer(false);
        timer = new Timer(false);
        loader = new Loader();
        Laya.systemTimer = Timer.gSysTimer = systemTimer;
        Laya.timer = timer;
        Laya.physicsTimer = physicsTimer;
        Laya.loader = loader;
        ILaya.systemTimer = systemTimer;
        ILaya.physicsTimer = physicsTimer;
        ILaya.timer = timer;
        ILaya.loader = loader;
        WeakObject.__init__();
        Mouse.__init__();
        let steps = [];
        if (LayaEnv.beforeInit)
            steps.push(() => LayaEnv.beforeInit(stageConfig));
        Laya._beforeInitCallbacks.forEach(func => steps.push(() => func(stageConfig)));
        steps.push(() => LayaGL.renderDeviceFactory.createEngine(null, Browser.mainCanvas));
        steps.push(() => Laya.initRender2D(stageConfig));
        let laya3D = window["Laya3D"];
        if (laya3D)
            steps.push(() => laya3D.__init__());
        steps.push(() => Promise.all(Laya._initCallbacks.map(func => func())));
        steps.push(() => {
            let p = Promise.resolve();
            for (let func of Laya._afterInitCallbacks)
                p = p.then(func);
            return p;
        });
        if (LayaEnv.afterInit)
            steps.push(() => LayaEnv.afterInit());
        let p = Promise.resolve();
        for (let step of steps)
            p = p.then(step);
        return p;
    }
    static _setStyleInfo(mainCanv) {
        let style = mainCanv.source.style;
        style.position = 'absolute';
        style.top = style.left = "0px";
        style.background = "#000000";
    }
    static initRender2D(stageConfig) {
        stage = window.stage = ILaya.stage = Laya.stage = new Stage();
        VertexElementFormat.__init__();
        VertexMesh.__init__();
        Shader3D.init();
        MeshQuadTexture.__int__();
        MeshVG.__init__();
        MeshTexture.__init__();
        Laya.render = Laya.createRender();
        render = Laya.render;
        stage.size(stageConfig.designWidth, stageConfig.designHeight);
        if (stageConfig.scaleMode)
            stage.scaleMode = stageConfig.scaleMode;
        if (stageConfig.screenMode)
            stage.screenMode = stageConfig.screenMode;
        if (stageConfig.alignV)
            stage.alignV = stageConfig.alignV;
        if (stageConfig.alignH)
            stage.alignH = stageConfig.alignH;
        if (Config.isAlpha)
            stage.bgColor = "#00000000";
        else if (stageConfig.backgroundColor)
            stage.bgColor = stageConfig.backgroundColor;
        if (LayaEnv.isConch && window.conch.setGlobalRepaint) {
            window.conch.setGlobalRepaint(stage.setGlobalRepaint.bind(stage));
        }
        RenderStateContext.__init__();
        RenderSprite.__init__();
        Material.__initDefine__();
        InputManager.__init__(stage, Render.canvas);
        if (LayaEnv.isConch && window.conchConfig.getOS() != "Conch-window") {
            Input.isAppUseNewInput = true;
        }
        Input.__init__(Render.canvas);
        SoundManager.autoStopMusic = true;
        Value2D._initone(RenderSpriteData.Texture2D, TextureSV);
        Value2D._initone(RenderSpriteData.Primitive, PrimitiveSV);
    }
    static createRender() {
        return new Render(0, 0, Browser.mainCanvas);
    }
    static alertGlobalError(value) {
        var erralert = 0;
        if (value) {
            Browser.window.onerror = function (msg, url, line, column, detail) {
                if (erralert++ < 5 && detail)
                    this.alert("出错啦，请把此信息截图给研发商\n" + msg + "\n" + detail.stack);
            };
        }
        else {
            Browser.window.onerror = null;
        }
    }
    static _runScript(script) {
        return Browser.window[Laya._evcode](script);
    }
    static addInitCallback(callback) {
        Laya._initCallbacks.push(callback);
    }
    static addBeforeInitCallback(callback) {
        Laya._beforeInitCallbacks.push(callback);
    }
    static addAfterInitCallback(callback) {
        Laya._afterInitCallbacks.push(callback);
    }
    static addReadyCallback(callback) {
        Laya._readyCallbacks.push(callback);
    }
    static _invokeReadyCallbacks() {
        return Promise.all(Laya._readyCallbacks.map(func => func())).then(() => { });
    }
    static importNative(name) {
        if (!LayaEnv.isConch)
            return null;
        let path = window.$DLL_PATHS[name];
        let obj = window.importNative(path || name);
        if (!obj)
            throw new Error(`failed to load ${name}`);
        return obj;
    }
}
Laya.stage = null;
Laya.systemTimer = null;
Laya.physicsTimer = null;
Laya.timer = null;
Laya.loader = null;
Laya._inited = false;
Laya._initCallbacks = [];
Laya._beforeInitCallbacks = [];
Laya._afterInitCallbacks = [];
Laya._readyCallbacks = [];
Laya._evcode = "eva" + "l";
ILaya.Laya = Laya;
ILaya.Loader = Loader;
ILaya.Context = Context;
ILaya.Browser = Browser;
ILaya.InputManager = InputManager;
export var init = Laya.init;
export var stage;
export var systemTimer;
export var physicsTimer;
export var timer;
export var loader;
export var render;
export var alertGlobalError = Laya.alertGlobalError;
export var addInitCallback = Laya.addInitCallback;
export var addBeforeInitCallback = Laya.addBeforeInitCallback;
export var addAfterInitCallback = Laya.addAfterInitCallback;
export var addReadyCallback = Laya.addReadyCallback;
export var importNative = Laya.importNative;
